import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';

type DetailsRowProps = PropsWithChildren<{ className?: string }>;

export const DetailsRow: FunctionComponent<DetailsRowProps> = ({ className, children }) => {
    const rowClasses = 'display-flex gap-25 align-items-start';
    return <div className={classNames(rowClasses, className)}>{children}</div>;
};
